<div class="container my-4">
    <div class="row">
        <div class="col-12">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" src="assets/images/svg/back-button.svg"
                    class="pointer img_sat" width="30px" height="30px" (click)="goback()">
                Network Events
            </span>
        </div>
    </div>
    <div class="card card_content">

        <form [formGroup]="form">
            <div class="card card_content">

                <!-- <div class="row">
                    <div class="col-2"></div>

                    <div class="col-sm-12 col-md-4 mt-1">
                        <p style="font-size: medium;margin-bottom: 3px;">Event Id:</p>
                        <h5 style="color:#4f4f4f">{{value.prefixed_id}}</h5>
                    </div>
                    <div class="col-sm-12 col-md-5 mt-1">
                        <p style="font-size: medium;margin-bottom: 3px;">Current Status:</p>
                        <h5 style="color:#4f4f4f">{{value.status}}</h5>
                    </div>

                </div>
                <div class="row">
                    <div class="col-3"></div>

                    <div class="col-sm-12 col-md-4 mt-1">
                        <p style="font-size: medium;margin-bottom: 3px;">Start Date:</p>
                        <h5 style="color:#4f4f4f">{{value.date_created}}</h5>
                    </div>
                    <div class="col-sm-12 col-md-5">
                        <p style="font-size: medium;margin-bottom: 3px;">Start Date:</p>
                        <h5 style="color:#4f4f4f">{{value.event_start_date|date:'yyyy-MM-dd'}}</h5>
                    </div>
                </div>
            </div> -->
            <div class="row">
                <div class="col-1"></div>
                <div class="col-sm-12 col-md-2 mt-1">
                    <p style="font-size: medium;margin-bottom: 3px;">Event Id:</p>
                    <h5 style="color:#4f4f4f">{{value.prefixed_id}}</h5>
                </div>
                <div class="col-sm-12 col-md-4 mt-1 mr-4">
                    <p style="font-size: medium;margin-bottom: 3px;">Current Status:</p>
                    <h5 style="color:#4f4f4f">{{value.status}}</h5>
                </div>


                <div class="col-sm-12 col-md-2 mt-1">
                    <p style="font-size: medium;margin-bottom: 3px;">Start Date:</p>
                    <h5 style="color:#4f4f4f">{{value.date_created}}</h5>
                </div>
                <div class="col-sm-12 col-md-2">
                    <p style="font-size: medium;margin-bottom: 3px;">Start Date:</p>
                    <h5 style="color:#4f4f4f">{{value.event_start_date|date:'yyyy-MM-dd'}}</h5>
                </div>
        </div>
        </div>

            <div class="cssmtgb just_center mt-3">
                <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start">
                    <mat-tab label="Event Details">
                        <div class="row mt-3">
                            <div class=" col-4 my-4">
                                <div class="row">
                                    <div class="col">
                                        <span class="title_header_bar">Current Status</span>
                                    </div>
                                </div>

                                <div class="card card_content" style="background-color: #fdf6ff; width: 367px;">
                                    <!-- Repeated content with flex layout -->
                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Event Type:</div>
                                        <h5 class="status-value">{{value.event_type||'--'}}</h5>
                                    </div>

                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Root Cause:</div>
                                        <h5 class="status-value">{{value.root_cause_inflicted_by||'--'}}</h5>
                                    </div>

                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Duration:</div>
                                        <h5 class="status-value">{{value.duration||'--'}}</h5>
                                    </div>

                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Urgency:</div>
                                        <h5 class="status-value">{{value.urgency||'--'}}</h5>
                                    </div>

                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Grade:</div>
                                        <h5 class="status-value">{{value.grade||'--'}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class=" col-4 my-4">
                                <div class="row">
                                    <div class="col">
                                        <span class="title_header_bar">Service Impact</span>
                                    </div>
                                </div>

                                <div class="card card_content" style="background-color: #fdf6ff; width: 367px;">
                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Impact:</div>
                                        <h5 class="status-value ml-3">{{value.impact||'--'}}</h5>
                                    </div>

                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Network Type/s:</div>
                                        <h5 class="status-value ml-3">{{value.network_type||'--'}}</h5>
                                    </div>

                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Product Type/s:</div>
                                        <h5 class="status-value ml-3">{{value.product||'--'}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class=" col-4 my-4">
                                <div class="row">
                                    <div class="col">
                                        <span class="title_header_bar">Affected Areas</span>
                                    </div>
                                </div>

                                <div class="card card_content" style="background-color: #fdf6ff; width: 367px;">
                                    <!-- Repeated content with flex layout -->
                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">City / Cities:</div>
                                        <h5 class="status-value">{{value.city||'--'}}</h5>
                                    </div>

                                    <div class="mt-1 d-flex flex-container">
                                        <div class="label">Suburb/s:</div>
                                        <h5 class="status-value">{{value.suburb||'--'}}</h5>
                                    </div>


                                </div>
                            </div>
                        </div>



                    </mat-tab>
                    <mat-tab label="User Affected">

                        <div class="table-responsive mt-2 mt-4">
                            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
                                <ng-container matColumnDef="Name">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Name">Name
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">
                                            {{dataField.name}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Surname">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Surname">Surname
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">
                                            {{dataField.surname}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Phonenumber">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Phonenumber">Phone
                                        number</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">
                                            {{dataField.cellNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Email">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Email">Email</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">
                                            {{dataField.emailForCSV }}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="NetworkIdentifier">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="NetworkIdentifier">Network
                                        Identifier</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">
                                            {{dataField.networkIdentifier }}</p>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                                </mat-row>
                            </mat-table>
                        </div>
                        <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                            <p>No data found</p>
                        </div>
                        <div class="table_pagenation">
                            <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length"
                                [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                            </mat-paginator>
                        </div>









                        <!-- <div class="row">
                            <div class="col-sm-12 col-md-6 mt-1">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Name</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="name"
                                        placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-1">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Sur Name:</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="surname"
                                        placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>

                        </div>
                        <div class="row">

                            <div class="col-sm-12 col-md-6 mt-2">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Phone Number:</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="cellNumber"
                                        placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-2">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Email:</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="emailForCSV"
                                        placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>

                        </div>
                        <div class="row">

                            <div class="col-sm-12 col-md-6 mt-2">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Network Identifier:</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="networkIdentifier"
                                        placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div> -->
                    </mat-tab>
                </mat-tab-group>

            </div>
        </form>

    </div>